import type { IHero } from '../types';

export const useHeroMedia = (heroProps: Pick<IHero, 'image' | 'mediaType' | 'loopingVideo' | 'poster' | 'rive' | 'videoUrl'>) => {
  const { image, mediaType, loopingVideo, poster, rive, videoUrl } = heroProps;
  
  const heroWithImage = !!image?.gatsbyImage;
  const hasMedia = Boolean((mediaType === 'image' && heroWithImage) || 
                   (mediaType === 'loopingVideo' && loopingVideo && poster?.gatsbyImage) || 
                   (mediaType === 'videoModal' && heroWithImage && videoUrl) || 
                   (mediaType === 'rive' && rive?.riveFile));

  return {
    heroWithImage,
    hasMedia,
  };
};
